import { formOptions } from '@tanstack/react-form';

import { contactFiltersDefaultObj, surveyFiltersDefaultObj } from '../../../utils';

const ageMin = 0;
const ageMax = 120;

export const patientListFiltersFormOptions = formOptions({
	defaultValues: {
		study_id: [] as { name: string; id: string }[],
		criteria_include: [] as { name: string; id: string }[],
		criteria_exclude: [] as { name: string; id: string }[],
		hci_id: [] as { name: string; id: string }[],
		age: [ageMin, ageMax],
		gender: [] as string[],
		legal_sex: [] as string[],
		status: [] as string[],
		patient_ids_include: [] as string[],
		patient_ids_exclude: [] as string[],
		needs_assistance: '',
		survey_filters: [surveyFiltersDefaultObj],
		contact_filters: [contactFiltersDefaultObj],
		survey_needs_assistance: '',
		survey_from_date: '',
		survey_to_date: '',
		max_results: '',
		person_lists_include: [] as { name: string; id: string }[],
		person_lists_exclude: [] as { name: string; id: string }[],
	},
});
